import { render } from "./BuilderOpenMessageReviewQuote.vue?vue&type=template&id=66ac1e4e&scoped=true&ts=true&lang=pug"
import script from "./BuilderOpenMessageReviewQuote.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderOpenMessageReviewQuote.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderOpenMessageReviewQuote.vue?vue&type=style&index=0&id=66ac1e4e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ac1e4e"]])

export default __exports__